import { z } from 'zod';
// Postgres has no year zero, even though ISO date syntax permits one.
const calendarDate = z.iso.date().refine((value) => !value.startsWith('0000-'), 'invalid year');
const boardFields = {
    filter: z.enum(['feature', 'maintenance', 'no_charge', 'needs_attention', 'mine']).optional(),
    kind: z.enum(['feature', 'maintenance', 'needs_triage']).optional(),
    attention: z.enum(['any', 'decision', 'reply']).optional(),
    billing: z.enum(['billable', 'no_charge']).optional(),
    /** Inclusive calendar dates in UTC, independent of the API host timezone. */
    submittedFrom: calendarDate.optional(),
    submittedTo: calendarDate.optional(),
    sort: z.enum(['updated', 'submitted_newest', 'submitted_oldest']).optional(),
    q: z.string().trim().max(200).optional(),
};
function validRange(options) {
    return (options.submittedFrom === undefined ||
        options.submittedTo === undefined ||
        options.submittedFrom <= options.submittedTo);
}
const rangeError = { path: ['submittedTo'], message: 'must be on or after submittedFrom' };
export const BoardOptionsSchema = z.strictObject(boardFields).refine(validRange, rangeError);
export const BoardQuerySchema = z
    .strictObject({
    ...boardFields,
    project: z.string().min(1).max(64),
    /** Filters and ordering apply to the full matching dataset before this response cap. */
    limit: z.coerce.number().int().min(1).max(200).default(200),
})
    .refine(validRange, rangeError);
//# sourceMappingURL=board.js.map